// Central adapter registry. To add a new county, write an adapter file under
// `./adapters/` and register it here. No new components, routes, or save logic.

import type { CountyAdapter } from "./types";
import { lapeerAdapter } from "./adapters/lapeer";
import { antrimAdapter } from "./adapters/antrim";
import { newaygoAdapter } from "./adapters/newaygo";
import { champaignAdapter } from "./adapters/champaign";
import { medinaAdapter } from "./adapters/medina";
import { muskingumAdapter } from "./adapters/muskingum";
import { midlandAdapter } from "./adapters/midland";
import { otsegoAdapter } from "./adapters/otsego";
import { deltaAdapter } from "./adapters/delta";
import { menomineeAdapter } from "./adapters/menominee";

export const countyAdapters: Record<string, CountyAdapter> = {
  lapeer: lapeerAdapter,
  antrim: antrimAdapter,
  newaygo: newaygoAdapter,
  champaign: champaignAdapter,
  medina: medinaAdapter,
  muskingum: muskingumAdapter,
  midland: midlandAdapter,
  otsego: otsegoAdapter,
  delta: deltaAdapter,
  menominee: menomineeAdapter,
};

export const getAdapter = (countyId: string): CountyAdapter | undefined =>
  countyAdapters[countyId];
